"use client";

import { X } from "lucide-react";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

// Pinned to light: the PDS has no dark mode (branding.md §8), and Sonner's
// "system" theme gave a dark-mode OS a black close button and a grey action
// on our white toast.
//
// Sonner injects its own sheet at runtime, and its `[data-sonner-toast]
// [data-styled] [data-…]` selectors out-rank a utility class, so the parts it
// styles (close button, action button) only take ours with `!`.
//
// The close X and the action follow the PDS toast (Figma PDS 164:1458): a bare
// X inside the top-right corner, and a small primary button.
const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    theme="light"
    className="toaster group"
    icons={{ close: <X className="size-4" /> }}
    toastOptions={{
      classNames: {
        toast:
          "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:has-[[data-close-button]]:pr-8",
        // On the first line rather than centred on a wrapped message, as in
        // the PDS alert.
        icon: "self-start mt-0.5",
        description: "group-[.toast]:text-muted-foreground",
        actionButton:
          "!h-8 !rounded-full !bg-primary !px-3 !font-sans !text-xs !font-medium !text-primary-foreground hover:!bg-primary/90",
        cancelButton:
          "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        closeButton:
          "!left-auto !right-2 !top-2 !size-4 !transform-none !border-0 !bg-transparent !text-foreground opacity-70 transition-opacity hover:opacity-100",
      },
    }}
    {...props}
  />
);

export { Toaster, toast };
